import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { reducer } from './store/remove-report-filters.reducers';
import { RemoveReportFiltersEffects } from './store/remove-report-filters.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    EffectsModule.forFeature([RemoveReportFiltersEffects]),
    StoreModule.forFeature('removeReportFilters', reducer),
  ]
})
export class RemoveReportFiltersModule { }
